import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Row, Col } from "react-bootstrap";
import { SelectInput } from "../../components/inputs/Select";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { addSpecialCase, getSpecialCases } from "../../components/collabs/collabsSlice";
import { Calendar } from "primereact/calendar";
import Langs from "../../app/lang/langs";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";

const AddSpecialCaseDialog = ({ visible, onHide }) => {

    const dispatch = useDispatch()
    const allCollabs = useSelector((state) => state.collabs.allCollabsList)
    const specialCasesOptions = useSelector((state) => state.collabs.specialCasesOptions)

    const [specialCaseData, setSpecialCaseData] = useState({})

    const [errors, setErrors] = useState({})

    const validate = () => {
        const newErrors = {}
        if (!specialCaseData.id_collab) newErrors.id_collab = "Collaborateur est obligatoire";
        if (!specialCaseData.case) newErrors.case = "Cas est obligatoire";
        if (!specialCaseData.start_date) newErrors.start_date = "Date de début est obligatoire";
        if (!specialCaseData.end_date) newErrors.end_date = "Date de fin est obligatoire";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0
    }

    const formatDateForDB = (date) => {
        if (!date) return null
        const d = new Date(date)
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    }

    const handleSubmit = async () => {
        if (!validate()) return

        try {
            const formattedData = {
                ...specialCaseData,
                start_date: formatDateForDB(specialCaseData.start_date),
                end_date: formatDateForDB(specialCaseData.end_date),
            };
            const response = await dispatch(
                addSpecialCase({
                    special_case: formattedData,
                })
            )

            if (response.payload.responseData.status === 1) {
                showSuccessToast("Cas spécial ajouté avec succès !")
                dispatch(getSpecialCases())
                onHide()
                setSpecialCaseData({})
            } else {
                showErrorToast(response.payload.error || "Échec de l'ajout du cas spécial.")
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout du cas spécial :", error)
            showErrorToast("Erreur interne du serveur.")
        }
    }

    const handleChange = (field, value) => {
        setSpecialCaseData((prev) => ({
            ...prev,
            [field]: value
        }))
        setErrors((prev) => ({
            ...prev,
            [field]: ""
        }))
    }

    return (
        <Dialog
            header="Ajouter un cas spécial"
            visible={visible}
            style={{ width: "50vw" }}
            modal
            onHide={() => {
                onHide();
                setSpecialCaseData({})
            }}
        >
            <div className="p-fluid">

                <Row className="mt-2 mb-5">
                    <Col md={3}>
                        <label><b>Collaborateur</b></label>
                    </Col>
                    <Col md={9}>
                        <Dropdown
                            filter
                            options={allCollabs.map((collab) => ({ label: collab.label, value: collab.id }))}
                            value={specialCaseData.id_collab}
                            onChange={(e) => handleChange("id_collab", e.value)}
                            placeholder="Sélectionnez un collaborateur"
                            className={errors.id_collab ? "p-invalid" : ""}
                        />
                        {errors.id_collab && <small className="p-error">{errors.id_collab}</small>}
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col md={3}>
                        <label><b>Cas</b></label>
                    </Col>
                    <Col md={9}>
                        <Dropdown
                            options={specialCasesOptions}
                            value={specialCaseData.case}
                            onChange={(e) => handleChange("case", e.value)}
                            placeholder="Sélectionnez un cas"
                            className={errors.case ? "p-invalid" : ""}
                        />
                        {errors.case && <small className="p-error">{errors.case}</small>}
                    </Col>
                </Row>

                <Row className="mb-5 align-items-center">
                    <Col md={3}>
                        <label><b>Date de début</b></label>
                    </Col>
                    <Col md={9}>
                        <Calendar
                            value={specialCaseData.start_date}
                            onChange={(e) => handleChange("start_date", e.value)}
                            dateFormat="dd/mm/yy"
                            showIcon
                            placeholder="Sélectionnez une date"
                            className={errors.start_date ? "p-invalid w-100" : "w-100"}
                        />
                        {errors.start_date && <small className="p-error">{errors.start_date}</small>}
                    </Col>
                </Row>

                <Row className="mb-5 align-items-center">
                    <Col md={3}>
                        <label><b>Date de fin</b></label>
                    </Col>
                    <Col md={9}>
                        <Calendar
                            value={specialCaseData.end_date}
                            onChange={(e) => handleChange("end_date", e.value)}
                            dateFormat="dd/mm/yy"
                            showIcon
                            placeholder="Sélectionnez une date"
                            className={errors.end_date ? "p-invalid w-100" : "w-100"}
                            minDate={specialCaseData.start_date || null}
                        />
                        {errors.end_date && <small className="p-error">{errors.end_date}</small>}
                    </Col>
                </Row>
                <Row className="mb-5 align-items-center">
                    <Col md={3}>
                        <label><b><Langs str="Comments" /></b></label>
                    </Col>
                    <Col md={9}>
                        <InputTextarea
                            value={specialCaseData.comments}
                            onChange={(e) => handleChange("comments", e.target.value)}
                            className={errors.case ? "p-invalid" : ""}
                            rows={4}
                        />
                        {errors.case && <small className="p-error">{errors.comments}</small>}
                    </Col>
                </Row>
                <Row className="mb-1">
                    <Col md={3}>
                        <PrimaryButton title="Annuler" active={true} onClick={onHide} />
                    </Col>
                    <Col md={6}>
                    </Col>
                    <Col md={3}>
                        <PrimaryButton title="Ajouter" active={true} onClick={handleSubmit} />
                    </Col>
                </Row>
            </div>
        </Dialog>
    );
};

export default AddSpecialCaseDialog;
